export const filterItemsData = {
    checkKeys(cartoon) {
        let keys = ['categories', 'authorsId', 'ageGroup', 'type', 'rating'];
        if (cartoon)
          keys = keys.filter((key) => ['categories', 'ageGroup'].includes(key));
        return keys;
      },
}